var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"signature mb-6"},[_c('card-title',{attrs:{"icon":'mdi-upload',"title":'Signature'}}),_c('signature',{attrs:{"url_signature":_vm.doctor.signature_url,"signature":_vm.doctor.signature},on:{"saveSignature":_vm.saveSignature}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }